/**
 * Patient Education Finder - Zipcode Lookup Feature
 * Main entry point for the zipcode-finder feature
 */

import PatientEducationFinder from './classes/patient-education-finder.class.js'

export { PatientEducationFinder }

// Re-export for convenience
export default PatientEducationFinder 